;(function(){
  try {
    var key = Object.getOwnPropertyNames(window).find(function(k){ return k && String(k).indexOf('untamed_protection_') === 0; });
    if (key && window[key] && window[key].disabled) return;
  } catch (_) {}

  function parseBool(val){ return String(val).toLowerCase() === 'true'; }

  function initRecentPurchaseToast(){
    var container = document.getElementById('purchase-toast-container');
    var template = document.getElementById('purchase-toast-template');
    if (!container || !template) return;

    var data = container.dataset || {};
    var toastVariant = data.toastVariant || 'white';
    var toastRounding = data.toastRounding || 'none';
    var maxToasts = parseInt(data.maxToasts || '3', 10);
    var toastDuration = parseInt(data.toastDuration || '5', 10);
    var toastInterval = parseInt(data.toastInterval || '20', 10);
    var useRandomProducts = parseBool(data.useRandomProducts || 'true');
    var maxRandomProducts = parseInt(data.maxRandomProducts || '10', 10);
    var defaultNames = []; var defaultCities = [];
    try { defaultNames = JSON.parse(data.defaultNames || '[]'); } catch(_) {}
    try { defaultCities = JSON.parse(data.defaultCities || '[]'); } catch(_) {}
    var currentProductId = data.currentProductId || '';

    var state = {
      toasts: [],
      activeToasts: 0,
      products: [],
      suppressedByUser: sessionStorage.getItem('purchase_toast_suppressed') === 'true',
      cycleInterval: null
    };

    if (state.suppressedByUser) return;

    function preloadImages(products){
      if (!products || !products.length) return;
      var preloadContainer = document.createElement('div');
      preloadContainer.style.position = 'absolute';
      preloadContainer.style.width = '0';
      preloadContainer.style.height = '0';
      preloadContainer.style.overflow = 'hidden';
      preloadContainer.style.visibility = 'hidden';
      document.body.appendChild(preloadContainer);
      products.forEach(function(product){
        var imageSrc = null;
        if (product.images && product.images.length > 0) imageSrc = product.images[0];
        else if (product.featured_image) imageSrc = (typeof product.featured_image === 'string') ? product.featured_image : product.featured_image.src;
        else if (product.image) imageSrc = (typeof product.image === 'string') ? product.image : product.image.src;
        else if (product.media && product.media.length > 0 && product.media[0].src) imageSrc = product.media[0].src;
        if (imageSrc && imageSrc.indexOf('//') === 0) imageSrc = 'https:' + imageSrc;
        if (imageSrc) { var img = new Image(); img.src = imageSrc; preloadContainer.appendChild(img); }
      });
    }

    function fallbackProducts(){
      var placeholder = 'data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2050%2050%22%3E%3Crect%20width%3D%2250%22%20height%3D%2250%22%20fill%3D%22%23eee%22%2F%3E%3Cpath%20d%3D%22M25%2015L35%2035H15z%22%20fill%3D%22%23aaa%22%2F%3E%3C%2Fsvg%3E';
      return [
        { title: 'Classic T-Shirt', images: [placeholder], url: '#' },
        { title: 'Designer Hoodie', images: [placeholder], url: '#' },
        { title: 'Premium Sneakers', images: [placeholder], url: '#' }
      ];
    }

    function getRandom(arr){ return arr[Math.floor(Math.random()*arr.length)]; }

    function getRandomProduct(){
      if (!state.products.length) return { title: 'Sample Product', images: [null], url: '#' };
      return getRandom(state.products);
    }

    function createToastElement(){
      var product = getRandomProduct();
      var name = defaultNames.length ? getRandom(defaultNames) : 'Customer';
      var city = defaultCities.length ? getRandom(defaultCities) : 'Somewhere';
      var times = ['Just now','2 minutes ago','5 minutes ago','10 minutes ago','15 minutes ago','30 minutes ago','1 hour ago'];
      var time = getRandom(times);

      var toast = template.content.cloneNode(true).querySelector('.purchase-toast');
      toast.classList.add('purchase-toast--' + toastVariant);
      toast.classList.add('purchase-toast--rounding-' + toastRounding);
      toast.querySelector('.purchase-toast__name').textContent = name;
      toast.querySelector('.purchase-toast__location').textContent = city;
      toast.querySelector('.purchase-toast__product').textContent = 'Purchased ' + (product.title || 'Product');
      toast.querySelector('.purchase-toast__time').textContent = time;

      var imageElement = toast.querySelector('.purchase-toast__image');
      var imageSrc = null;
      if (product.images && product.images.length) imageSrc = product.images[0];
      else if (product.featured_image) imageSrc = (typeof product.featured_image === 'string') ? product.featured_image : product.featured_image.src;
      else if (product.image) imageSrc = (typeof product.image === 'string') ? product.image : product.image.src;
      else if (product.media && product.media.length && product.media[0].src) imageSrc = product.media[0].src;
      if (imageSrc && imageSrc.indexOf('//') === 0) imageSrc = 'https:' + imageSrc;
      imageElement.src = imageSrc || 'data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2050%2050%22%3E%3Crect%20width%3D%2250%22%20height%3D%2250%22%20fill%3D%22%23eee%22%2F%3E%3Cpath%20d%3D%22M25%2015L35%2035H15z%22%20fill%3D%22%23aaa%22%2F%3E%3C%2Fsvg%3E';
      imageElement.alt = product.title || 'Product';

      toast.querySelector('.purchase-toast__close').addEventListener('click', function(){
        state.suppressedByUser = true;
        sessionStorage.setItem('purchase_toast_suppressed', 'true');
        stopToastCycle();
        hideToast(toast);
      });

      return toast;
    }

    function showToast(){
      if (state.activeToasts >= maxToasts || state.suppressedByUser) return;
      var toast = createToastElement();
      container.appendChild(toast);
      state.toasts.push(toast);
      state.activeToasts++;
      toast.offsetHeight;
      setTimeout(function(){ toast.classList.add('is-visible'); }, 10);
      var dismissTime = toastDuration * 1000;
      toast.dismissTimer = setTimeout(function(){ hideToast(toast); }, dismissTime);
    }

    function hideToast(toast){
      if (toast.dismissTimer) clearTimeout(toast.dismissTimer);
      toast.classList.remove('is-visible');
      setTimeout(function(){
        if (toast.parentNode) toast.parentNode.removeChild(toast);
        var idx = state.toasts.indexOf(toast); if (idx > -1) state.toasts.splice(idx,1);
        state.activeToasts--;
      }, 300);
    }

    function startToastCycle(){
      if (state.suppressedByUser) return;
      state.cycleInterval = setInterval(function(){ showToast(); }, toastInterval * 1000);
    }
    function stopToastCycle(){ if (state.cycleInterval) clearInterval(state.cycleInterval); }

    (async function loadProducts(){
      try {
        if (useRandomProducts) {
          if (Array.isArray(window.storeProducts) && window.storeProducts.length) {
            state.products = window.storeProducts;
          }
          if (!state.products.length && currentProductId) {
            try {
              var res = await fetch('/recommendations/products.json?product_id=' + encodeURIComponent(currentProductId) + '&limit=' + maxRandomProducts);
              var data = await res.json();
              if (data && data.products && data.products.length) state.products = data.products;
            } catch(_) {}
          }
          if (!state.products.length && window.productData) {
            state.products = [window.productData];
          }
          if (!state.products.length) {
            try {
              var res2 = await fetch('/collections/all/products.json?limit=' + maxRandomProducts);
              var data2 = await res2.json();
              if (data2 && data2.products && data2.products.length) state.products = data2.products;
            } catch(_) {}
          }
          if (!state.products.length) state.products = fallbackProducts();
        } else {
          if (window.productData) state.products = [window.productData];
          else if (Array.isArray(window.storeProducts) && window.storeProducts.length) state.products = window.storeProducts;
          else state.products = fallbackProducts().slice(0,1);
        }
      } catch(_) {
        state.products = fallbackProducts();
      }
      preloadImages(state.products);
      startToastCycle();
      setTimeout(function(){ showToast(); }, 3000);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecentPurchaseToast);
  } else {
    initRecentPurchaseToast();
  }

  document.addEventListener('shopify:section:load', function(){ initRecentPurchaseToast(); });
})();


